/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Deep_P3Inputs */

const en_to_yaml_deep_p3 = /** @type {(inputs: To_Yaml_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Long strings are folded rather than wrapped mid token. Past the 120 character line width, a scalar is written as a folded block using the greater than and minus indicators, which tells a YAML reader to join the wrapped lines back into a single line and strip the trailing newline. It looks unfamiliar but round trips exactly. Anchors and aliases are disabled, so a value repeated in two places is written out twice rather than referenced, which keeps the output readable at the cost of some bytes.`)
};

const ko_to_yaml_deep_p3 = /** @type {(inputs: To_Yaml_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`긴 문자열은 토큰 중간에서 줄바꿈되지 않고 접힙니다. 120자 줄 너비를 넘으면 스칼라가 부등호와 빼기 지시자를 쓰는 접힌 블록으로 작성되는데, 이는 YAML 리더에게 나뉜 줄을 한 줄로 다시 이어붙이고 마지막 줄바꿈을 없애라고 알려줍니다. 낯설어 보이지만 정확하게 왕복합니다. 앵커와 별칭은 비활성화되어 있으므로, 두 곳에 반복되는 값은 참조되지 않고 두 번 써집니다. 바이트를 조금 더 쓰는 대가로 출력의 가독성을 지킵니다.`)
};

const ja_to_yaml_deep_p3 = /** @type {(inputs: To_Yaml_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長い文字列はトークンの途中で折り返されるのではなく畳まれます。120 文字の行幅を超えると、スカラーは大なり記号とマイナス記号の指示子を使う畳み込みブロックとして書かれ、これは YAML リーダに分かれた行を 1 行に戻し末尾の改行を取り除くよう伝えます。見慣れませんが正確に往復します。アンカーとエイリアスは無効なので、2 か所に繰り返される値は参照されず 2 度書き出されます。バイト数を少し使う代わりに出力の可読性を保ちます。`)
};

/**
* | output |
* | --- |
* | "Long strings are folded rather than wrapped mid token. Past the 120 character line width, a scalar is written as a folded block using the greater than and mi..." |
*
* @param {To_Yaml_Deep_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_deep_p3 = /** @type {((inputs?: To_Yaml_Deep_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Deep_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_deep_p3(inputs)
	if (locale === "ko") return ko_to_yaml_deep_p3(inputs)
	return ja_to_yaml_deep_p3(inputs)
});